import React, { useState, useEffect } from 'react';
import { Handshake, MapPin, Loader2 } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const FALLBACK_PARTNERS = [
  { name: 'ANAREDA', product: 'Epicerie Vrac', photo: 'https://static.wixstatic.com/media/11062b_b4276c5434ed412b8c62e76c7a96dfe9~mv2.jpeg/v1/fill/w_400,h_300,al_c,q_80,enc_avif,quality_auto/Shopping%20Epicerie.jpeg' },
  { name: 'A STRADA CAMPAGNOLA', product: 'Produits locaux', photo: 'https://static.wixstatic.com/media/ce6ce7_b4201688d37143ad9ab1acfd6c66d3ba~mv2.png/v1/fill/w_400,h_180,al_c,q_85,enc_avif,quality_auto/A%20STRADA%20CAMPAGNOLA.png' },
  { name: 'BOUCHERIE J.J DE PERETTI', product: 'Viandes locales', photo: 'https://static.wixstatic.com/media/11062b_b49a99ea2dc14daa9b6149e23d930414~mv2.jpg/v1/fill/w_400,h_300,al_c,q_80,enc_avif,quality_auto/Viande%20sur%20une%20planche%20%C3%A0%20d%C3%A9couper.jpg' },
  { name: 'GRAZIA DOLCE AMORE', product: 'Glaces artisanales', photo: 'https://static.wixstatic.com/media/ce6ce7_c769e03e813744b395a26d3aecaa8bde~mv2.jpeg/v1/fill/w_400,h_500,al_c,q_80,enc_avif,quality_auto/GRAZIA%20DOLCE%20AMORE.jpeg' },
];

const PartnersSection = () => {
  const [partners, setPartners] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPartners = async () => {
      try {
        const res = await axios.get(`${API}/public/suppliers`);
        setPartners(res.data.length > 0 ? res.data : FALLBACK_PARTNERS);
      } catch {
        setPartners(FALLBACK_PARTNERS);
      } finally { setLoading(false); }
    };
    fetchPartners();
  }, []);

  if (loading) return (
    <section className="py-24 bg-[#F5F3EF]">
      <div className="flex justify-center"><Loader2 className="h-8 w-8 animate-spin text-[#C4724F]" /></div>
    </section>
  );

  return (
    <section className="py-24 bg-[#F5F3EF]" data-testid="partners-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#C4724F]/10 rounded-full mb-4">
            <Handshake className="h-4 w-4 text-[#C4724F]" />
            <span className="text-[#C4724F] font-medium text-sm">Collaboration responsable</span>
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1D3557] mb-6">
            Nous travaillons uniquement avec des <span className="italic text-[#C4724F]">acteurs locaux</span>
          </h2>
          <p className="text-[#4A5568] text-lg max-w-3xl mx-auto">
            Une collaboration responsable et engagee avec des producteurs locaux, 
            des artisans passionnes qui partagent nos valeurs de circuits courts et de qualite.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {partners.map((partner, index) => (
            <div 
              key={partner.id || index}
              className="group bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-lg transition-all duration-300"
              data-testid={`partner-${index}`}
            >
              <div className="h-32 overflow-hidden">
                <img
                  src={partner.photo?.startsWith('/api') ? `${process.env.REACT_APP_BACKEND_URL}${partner.photo}` : partner.photo}
                  alt={partner.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  onError={(e) => { e.target.src = 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 300"><rect fill="%23f0f0f0" width="400" height="300"/></svg>'; }}
                />
              </div>
              <div className="p-4 text-center">
                <h4 className="font-semibold text-[#1D3557] text-sm mb-1">{partner.name}</h4>
                <p className="text-xs text-[#4A5568]">{partner.product || partner.type}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <div className="inline-flex items-center gap-2 text-[#4A5568]">
            <MapPin className="h-5 w-5 text-[#2A9D8F]" />
            <span className="text-sm">Tous nos partenaires sont situes en Corse et dans nos destinations</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;
